/* eslint-disable react/jsx-no-bind */
import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "../../Modal";
import RichText from "../../Prismic/RichText";
import Button from "wonderbly-components/lib/Button";
import CloseIcon from "wonderbly-components/lib/CloseIcon";

import "./CanvasDrawerPrompt.scss";

const CanvasDrawerPrompt = (props) => {
  const [isOpen, setIsOpen] = useState(true);

  const onHandleClick = () => {
    props.setActiveDrawer(props.drawerKey);
    setIsOpen(false);
  };

  return (
    <Modal default isOpen={isOpen} className="CanvasDrawerPrompt">
      <div className="CanvasDrawerPrompt__inner">
        <div className="CanvasDrawerPrompt__header">
          <CloseIcon onHandleClick={() => setIsOpen(false)} color="#00294C" />
        </div>
        {props.title && (
          <h4 className="CanvasDrawerPrompt__title">{props.title}</h4>
        )}
        {props.description && (
          <RichText
            className="CanvasDrawerPrompt__description"
            fields={props.description}
          />
        )}
        <Button fullWidth onClick={onHandleClick}>
          {props.ctaBackText}
        </Button>
        {props.ctaHelper && (
          <p className="CanvasDrawerPrompt__helper">{props.ctaHelper}</p>
        )}
        <Button fullWidth onClick={props.onSubmitDrawers}>
          {props.ctaText}
        </Button>
      </div>
    </Modal>
  );
};

CanvasDrawerPrompt.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  ctaBackText: PropTypes.array,
  ctaHelper: PropTypes.string,
  ctaText: PropTypes.string,
  onSubmitDrawers: PropTypes.func,
  setActiveDrawer: PropTypes.func,
  drawerKey: PropTypes.string,
};

export default CanvasDrawerPrompt;
